import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { pickDefined, withClient } from './common.js';

export async function confirmCommand(args: ParsedArgs): Promise<CommandResult> {
  return { data: await withClient(args.options, (client) => client.request(Methods.Confirm)) };
}

export async function uiCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'state';
  if (action === 'state') {
    return { data: await withClient(args.options, (client) => client.request(Methods.UI)) };
  }
  if (action === 'respond') {
    const id = args.positionals[2] ?? flag(args.flags, 'id');
    const responseAction = flag(args.flags, 'action');
    if (!id || !responseAction) {
      throw new CliError('ui respond requires <id> --action <action>', ExitCode.Usage);
    }
    if (!['dismiss', 'select', 'confirm'].includes(responseAction)) {
      throw new CliError('--action must be dismiss, select, or confirm', ExitCode.Usage);
    }
    const choiceId = flag(args.flags, 'choice-id');
    if (responseAction === 'select' && !choiceId) {
      throw new CliError('--choice-id is required when --action is select', ExitCode.Usage);
    }
    const data = await withClient(args.options, (client) =>
      client.request(Methods.UIRespond, pickDefined({ id, action: responseAction, choiceId })),
    );
    return { data };
  }
  throw new CliError(`Unknown ui action "${action}"`, ExitCode.Usage);
}
